import { FC } from "react";
import { Stack } from "@mui/material";
import {
  WidgetSourceInfo,
  WidgetTitleProps,
} from "./source-and-name/WidgetSourceInfo";
import { WidgetCardHeaderActionRow } from "./WidgetCardHeaderActionRow";
import { WidgetType } from "../../../../../../../services/cloudchipr.api";

interface WidgetCardHeaderProps {
  hovered: boolean;
  widgetId: string;
  widgetType: WidgetType;
  widgetTitleProps: WidgetTitleProps | null;
}

export const WidgetCardHeader: FC<WidgetCardHeaderProps> = ({
  widgetId,
  widgetTitleProps,
  widgetType,
  hovered,
}) => {
  return (
    <Stack
      pl={2}
      pr={0}
      py={1}
      borderBottom={1}
      sx={{
        borderBottomColor: "grey.300",
        position: "sticky",
        top: 0,
        bgcolor: "white",
        zIndex: 2,
      }}
    >
      <WidgetCardHeaderActionRow
        widgetId={widgetId}
        hovered={hovered}
        widgetType={widgetType}
        widgetTitleProps={widgetTitleProps}
      />
      {widgetTitleProps && (
        <Stack spacing={0.5} overflow="hidden">
          <WidgetSourceInfo {...widgetTitleProps} />
        </Stack>
      )}
    </Stack>
  );
};
